import dayjs from 'dayjs';
import flatpickr from 'flatpickr';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import fetchLanguageResource from 'services/common/fetchLanguageResource';

import { setLocalization } from 'stores/layoutSlice';

import { languages } from 'utils/localization';

import useAppTracking from './useAppTracking';

const useChangeLanguage = () => {
	const { i18n } = useTranslation();
	const dispatch = useDispatch();
	const { update } = useAppTracking();
	const { initialized } = useSelector((state) => state.layout.localization);

	const changeLanguage = useCallback(
		async (language) => {
			if (initialized && i18n.language === language) {
				return;
			}
			const currentLanguageCode = language || 'engValue';
			const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
			const {
				code,
				name,
				systemCode,
				dir,
				languageCode = 'en',
				icon,
				dayjsLocale,
				flatpickrLocale,
				tinyMCELanguage,
				tinyMCELanguageUrl
			} = currentLanguage;
			await fetchLanguageResource(code);
			dispatch(
				setLocalization({
					code,
					name,
					dir,
					icon,
					tinyMCELanguage,
					tinyMCELanguageUrl,
					systemCode,
					initialized: true
				})
			);
			document.body.dir = dir || 'ltr';
			document.documentElement.setAttribute('lang', languageCode);
			i18n.changeLanguage(language);

			dayjs.locale(dayjsLocale);

			update({
				language: systemCode.split('_').shift(),
				locale: systemCode,
				// eslint-disable-next-line camelcase
				locale_code: systemCode
			});

			flatpickr.localize(flatpickrLocale);
		},
		[i18n]
	);

	return changeLanguage;
};

export default useChangeLanguage;
